export default class Link {
    constructor(readonly id: string, readonly linkedUrl: string, readonly active: boolean) {
        if (!id || !linkedUrl || active === null) {
            throw new ReferenceError('Undefined prop');
        }
    }
}
